import { c as _c } from "react/compiler-runtime";
import { GetProductReviewsOptions, GetProductReviewsResult } from '@spa/lib/graphql/product-reviews/getProductReviews';
import { SubmitProductReviewMetadataEntry, SubmitProductReviewPhoto } from '@spa/lib/graphql/product-reviews/submitProductReview';
import { GetProductReviewFormResult } from '@spa/lib/graphql/product-reviews/getProductReviewForm';
import { ProductReviewFeedbackVote } from '@spa/generated/graphql/graphql';
import { ReportProductReviewResult } from '@spa/lib/graphql/product-reviews/reportProductReview';
import { SubmitProductReviewHelpfulnessFeedbackResult } from '@spa/lib/graphql/product-reviews/submitProductReviewHelpfulnessFeedback';
import { SubmitProductReviewResult } from '@spa/lib/graphql/product-reviews/submitProductReview';
import { UploadProductReviewPhotoResult } from '@spa/lib/graphql/product-reviews/uploadProductReviewPhoto';
import getProductReviewFormAction from '@spa/lib/actions/productReviews/getProductReviewFormAction';
import getProductReviewsAction from '@spa/lib/actions/productReviews/getProductReviewsAction';
import reportProductReviewAction from '@spa/lib/actions/productReviews/reportProductReviewAction';
import submitProductReviewAction from '@spa/lib/actions/productReviews/submitProductReviewAction';
import submitProductReviewHelpfulnessFeedbackAction from '@spa/lib/actions/productReviews/submitProductReviewHelpfulnessFeedbackAction';
import uploadProductReviewPhotoAction from '@spa/lib/actions/productReviews/uploadProductReviewPhotoAction';
import { useCallback } from 'react';
export interface UseProductReviewsAPIResult {
  getProductReviews: (productCode: string, options?: GetProductReviewsOptions) => Promise<GetProductReviewsResult>;
  getProductReviewForm: (productCode: string) => Promise<GetProductReviewFormResult>;
  uploadProductReviewPhoto: (productCode: string, name: string, contentType: string, content: string) => Promise<UploadProductReviewPhotoResult>;
  submitProductReview: (productCode: string, rating: number, reviewText: string, title: string, userNickname: string, userEmail: string, isRecommended: boolean, photos: ReadonlyArray<SubmitProductReviewPhoto>, metadata: ReadonlyArray<SubmitProductReviewMetadataEntry>, deviceFingerprint: string | null) => Promise<SubmitProductReviewResult>;
  submitProductReviewHelpfulnessFeedback: (reviewId: string, vote: ProductReviewFeedbackVote) => Promise<SubmitProductReviewHelpfulnessFeedbackResult>;
  reportProductReview: (reviewId: string) => Promise<ReportProductReviewResult>;
}
export function useProductReviewsAPI() {
  const $ = _c(1);
  const getProductReviews = _temp;
  const getProductReviewForm = _temp2;
  const uploadProductReviewPhoto = _temp3;
  const submitProductReview = _temp4;
  const submitProductReviewHelpfulnessFeedback = _temp5;
  const reportProductReview = _temp6;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      getProductReviews,
      getProductReviewForm,
      reportProductReview,
      submitProductReview,
      submitProductReviewHelpfulnessFeedback,
      uploadProductReviewPhoto
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
async function _temp6(reviewId_0) {
  return reportProductReviewAction("reportProductReviewAction", reviewId_0);
}
async function _temp5(reviewId, vote) {
  return submitProductReviewHelpfulnessFeedbackAction("submitProductReviewHelpfulnessFeedbackAction", reviewId, vote);
}
async function _temp4(productCode_2, rating, reviewText, title, userNickname, userEmail, isRecommended, photos, metadata, deviceFingerprint) {
  return submitProductReviewAction("submitProductReviewAction", {
    productCode: productCode_2,
    rating,
    reviewText,
    title,
    userNickname,
    userEmail,
    isRecommended,
    photos,
    metadata,
    deviceFingerprint
  });
}
async function _temp3(productCode_1, name, contentType, content) {
  return uploadProductReviewPhotoAction("uploadProductReviewPhotoAction", {
    productCode: productCode_1,
    name,
    contentType,
    content
  });
}
async function _temp2(productCode_0) {
  return getProductReviewFormAction("getProductReviewFormAction", productCode_0);
}
async function _temp(productCode, options) {
  return getProductReviewsAction("getProductReviewsAction", productCode, options);
}
export default useProductReviewsAPI;